import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Flex, Heading1, Divider } from '@ubisend/pulse-components';
import { useQuery } from '@ubisend/pulse-hooks';

import { useAuth } from '../hooks/index';
import methods from '../Components/LoginMethods/index';
import {
  AnimatedAuthContainer,
  AuthErrorRedirect,
  LoggedInRedirect
} from '../Components/index';

const Login = () => {
  const { authenticated, loginUser } = useAuth();

  const location = useLocation();

  const code = new URLSearchParams(location?.search).get('code');

  const {
    data: callbackQueryData,
    isError: callbackQueryIsError,
    isSuccess: callbackQueryIsSuccess
  } = useQuery({
    queryKey: [`auth/oauth2/callback${location?.search}`],
    enabled: Boolean(code && !authenticated)
  });

  useEffect(() => {
    if (callbackQueryIsSuccess) {
      const { token, client, ...user } = callbackQueryData.data;
      loginUser({ user, token, client });
    }
  }, [callbackQueryData, callbackQueryIsSuccess, loginUser]);

  const {
    data: authData,
    isSuccess: authIsSuccess
  } = useQuery({
    queryKey: [
      'auth'
    ]
  });

  if (authenticated) {
    return <LoggedInRedirect />;
  }

  if (code && callbackQueryIsError) {
    return <AuthErrorRedirect />;
  }

  return (
    <AnimatedAuthContainer>
      {authIsSuccess && (
        <>
          <Heading1 style={{ fontSize: '2rem' }} mb textCenter>
            Login
          </Heading1>
          <Flex col ySpace>
            {authData.data.map((method, key) => {
              const { Login } = methods[method.name];

              return (
                <React.Fragment key={key}>
                  {key === 1 && <Divider text="Or" />}
                  <Login method={method} />
                </React.Fragment>
              );
            })}
          </Flex>
        </>
      )}
    </AnimatedAuthContainer>
  );
};

export default Login;
